import { Injectable } from "@angular/core";
import firebase from "firebase";
import { Movie } from "../data/Movie";
import { FirestoreService } from "./FirestoreService";

@Injectable()
export class MoviesService {
  constructor(private firestoreService: FirestoreService) {}

  getMovie(movieId: string) {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("movies")
        .doc(movieId)
        .get()
        .then(doc => {
          const movie = new Movie();

          movie.movieId = doc.id;
          movie.name = doc.data().name;
          movie.picture = doc.data().picture;
          movie.detailsPicture = doc.data().detailsPicture;
          movie.releaseYear = doc.data().releaseYear;
          movie.rating = doc.data().rating;
          movie.description = doc.data().description;
          movie.videoUrl = doc.data().videoUrl;
          movie.userRating = doc.data().userRating;
          movie.ratingsCount = doc.data().ratingsCount;
          movie.watchProgress = doc.data().watchProgress;
          movie.watchers = doc.data().watchers;
          movie.views = this.getMovieViews(movie.watchers);

          if(doc.data().premiumStatus !== undefined) {
              if(doc.data().premiumStatus == '1') {
                movie.premiumStatus = "1";
              } else {
                movie.premiumStatus = "0";
              }
          } else {
            movie.premiumStatus = "0"
          }


          resolve({ movie: movie });
        });
    });

    return promise;
  }

  getMovieViews(watchers) {
    let totalViews = 0;
    if(watchers !== undefined) {
      watchers.forEach(element => {
        totalViews += element.watchCount
      });
    }

    return totalViews;
  }

  updateMovieWatchHistory(movieId, watchers) {

    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('movies')
        .doc(movieId)
        .set({
          watchers: watchers
        }, { merge: true })
        .then(function() {
          resolve();
        })
        .catch(function(error) {
          console.error(error);
          reject(error);
        });
    });

    return promise;
  }

  rateMovie(movieId: string, rating: string) {
    let retrievedRating: Number = Number(rating);
    let averageRating: Number = 0;
    let bigRating: Number;
    let newBigRating: any;
    let newRating: any;
    let that = this;


    const promise = new Promise((resolve, reject) => {

      //Get rating
      this.getMovie(movieId).then((data: any) => {
        let movieRating = data.movie.userRating;
        let movieRatings = data.movie.ratingsCount;

        console.log(movieRating+' - retrieved rating');
        console.log(movieRatings+' - retrieved ratingsCount');

        if(movieRating == undefined) {
          retrievedRating = 0;
          movieRatings = 0;

          console.log(retrievedRating+' - retrieved rating');
          console.log(movieRatings+' - retrieved ratingsCount');

          //set rating
          this.setMovieRating(movieId, rating, 1);
        } else {
          retrievedRating = movieRating;
          movieRatings = movieRatings;
          bigRating = Number(retrievedRating) * Number(movieRatings);

          newBigRating = Number(bigRating) + Number(rating);
          let newRatingsCount = movieRatings+1
          newRating = newBigRating/newRatingsCount;



          this.setMovieRating(movieId, newRating, newRatingsCount);

        }

        //Update user rate history
        let uid = localStorage.getItem('loggedInUserUID')
        that.addMovieRateHistory(uid, movieId, rating);

        resolve();
      }).catch(function(error) {
        reject(error);
      });
    });

    return promise;
  }

  setMovieRating(movieId: string, rating, ratingsCount) {

    let that = this;
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("movies")
        .doc(movieId)
        .set(
          {
            userRating: rating,
            ratingsCount: ratingsCount
          },
          { merge: true }
        )
        .then(function() {



          resolve();
        })
        .catch(function(error) {
          reject(error);
        });
    });

    return promise;
  }

  addMovieRateHistory(userId: string, movieId, rating) {

    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection('users')
        .doc(userId)
        .collection('myRatedMovies')
        .doc()
        .set({
          addedAt: firebase.firestore.FieldValue.serverTimestamp(),
          tvShowId: movieId,
          rating: rating
        })
        .then(function() {
          resolve();
        })
        .catch(function(error) {
          console.error(error);
          reject(error);
        });
    });

    return promise;
  }

  getAllMovies() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("movies")
        .orderBy("addedAt", "desc")
        .get()
        .then(moviesSnapshot => {
          const movies = [];

          moviesSnapshot.forEach(doc => {
            const movie = new Movie();

            movie.movieId = doc.id;
            movie.name = doc.data().name;
            movie.picture = doc.data().picture;
            movie.detailsPicture = doc.data().detailsPicture;
            movie.releaseYear = doc.data().releaseYear;
            movie.rating = doc.data().rating;
            movie.description = doc.data().description;
            movie.videoUrl = doc.data().videoUrl;
            movie.ratingsCount = doc.data().ratingsCount;
            movie.userRating = doc.data().userRating;

            movies.push(movie);
          });

          resolve({ movies: movies });
        });
    });

    return promise;
  }

  getRecentlyAddedMovies() {
    const promise = new Promise((resolve, reject) => {
      const db = firebase.firestore();

      db.collection("movies")
        .limit(12)
        .orderBy("addedAt", "desc")
        .get()
        .then(moviesSnapshot => {
          const movies = [];

          moviesSnapshot.forEach(doc => {
            const movie = new Movie();

            movie.movieId = doc.id;
            movie.name = doc.data().name;
            movie.picture = doc.data().picture;
            movie.detailsPicture = doc.data().detailsPicture;
            movie.releaseYear = doc.data().releaseYear;
            movie.rating = doc.data().rating;
            movie.description = doc.data().description;
            movie.videoUrl = doc.data().videoUrl;

            movies.push(movie);
          });

          resolve({ movies: movies });
        });
    });

    return promise;
  }
}



// WEBPACK FOOTER //
// ./src/services/MoviesService.ts